<style>
	.badge-outline-success {
		background-color: transparent;
		border: 2px solid #27c24c;
	}

	.badge-margin {
		margin-right: 2px;
	}

	.nest-collapser {
		color: #424242;
		padding-left: 0px;
		padding-right: 10px;
	}

	.nest-row {
		padding-left: 0px;
	}

	.select-tree-items .checkbox {
		margin-left: 0px !important;
		text-align: left;
		padding-left: 0px;
	}

	.dd-filter .nestable-item {
		padding-left: 0px;
	}
</style>
<template>
	<section class="section-container" v-if="!is_supplier && (is_administrator || is_contractor)">
		<div class="content-wrapper">
			<div class="content-heading" v-if="tender.id">
				{{$t('category_report.edit-title')}}
			</div>
			<div class="content-heading" v-else>
				<div class="row" style="width:100%;">
					<div class="col-md-6 text-left pull-left">
						<div>{{$t('category_report.title')}}</div>
					</div>
					<div class="col-md-6 text-right pull-right">

					</div>
				</div>
			</div>
			<!-- Filtration -->
			<div class="row">
				<div class="col-xl-12">
					<div id="accordion">
						<div class="card mb-1">
							<div class="card-header" id="headingOne">
								<h4 class="mb-0">
									{{$t('category_report.search')}}
									<a class="text-inherit" data-toggle="collapse" data-target="#collapseOne"
									   aria-expanded="true" aria-controls="collapseOne" href="">
										<i class="icon-arrow-down"></i>
									</a>

								</h4>
							</div>
							<div class="collapse show" id="collapseOne" aria-labelledby="headingOne"
								 data-parent="#accordion">
								<div class="card-body border-top">
									<form>
										<div class="form-row align-items-center">
											<div class="col-md-6">
												<div class="row">
													<div class="col-md-8">
														<label class="sr-only" for="tarnija">
															{{$t('category_report.search-placeholder')}}
														</label>
														<input class="form-control mb-12" id="tarnija" type="text"
															   :placeholder="$t('category_report.search-placeholder')"
															   v-model="filter.search"
															   v-on:input="filterBySearchBar(searchBarInput)"
															   style="width:100%;">
													</div>
													<div class="col-md-3 no-pad">
														<div class="col-auto text-left pull-left no-pad">
															<button class="btn btn-success mb-2"
																	type="submit"
																	@click.prevent="filterRows()"
															>{{$t('category_report.search-submit')}}
															</button>
															<button class="btn btn-outline-info mb-2" type="cancel"
																	@click.prevent="resetFilters()">
																{{$t('category_report.search-cancel')}}
															</button>
														</div>
													</div>
												</div>

											</div>
											<div class="row xs-pad" style="width:100%;">
												<div class="col-md-12">

													<!-- Group selection -->
													<div class="row p-t-30">
														<div class="col-2" v-for="(group, idx) in groups"
															 :key="'group-'+idx">
															<div class="row text-left">
																<div class="col-md-2">
																	<div class="checkbox c-checkbox">
																		<label class="mb-0">
																			<input
																					type="checkbox"
																					class="select-box"
																					:id="group.id"
																					:checked="selectedDivision ==
																					group.id"
																					@click="filterByGroup(group.id, group.name)"
																			>
																			<span class="fa fa-check"> </span>
																		</label>
																	</div>
																</div>
																<div class="col-md-10">
																	<h5>{{group.name}}</h5>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>


										</div>
										<div class="form-row align-items-center padding-xs">
											<div class="dropdown-button filter-cat-select" data-droptree="1"
												 data-state="closed">
												<a href="#" class="dropdown-btn" @click="toggleTreeFilter()">
													{{$t('category_report.select-category')}}
													<i v-if="!treeFilterOpen" class="icon-arrow-down"></i>
													<i v-if="treeFilterOpen" class="icon-arrow-up"></i>
												</a>
											</div>
											<div class="dropdown-popup" v-if="treeFilterOpen" data-treeid="1"
												 data-state="closed">
												<div class="dropdown-tree-content">
													<div class="js-nestable-action">
														<div class="row">
															<div class="col-md-6">
																<a class="btn btn-secondary btn-sm mr-1"
																   @click="collapseExpand(false)">
																	{{$t('category_report.expand-all')}}
																</a>
															</div>
															<div class="col-md-6 text-right pull-right">
																<a class="btn btn-secondary btn-sm"
																   @click="collapseExpand(true)">
																	{{$t('category_report.collapse-all')}}
																</a>
															</div>
														</div>
														<div class="row secondary">

														</div>
													</div>
													<div class="dd filter-tree-items dd-filter" id="nestable">
														<div class="no-content text-center" v-if="listItems.length ==
														 0">

															{{$t('category_select.select-group-first')}}
														</div>
														<div class="nestable-container" v-if="listItems.length > 0">
															<VueNestable
																	v-model="listItems"
																	:max-depth="5"
																	:hooks="{
                                                                    'beforeMove': beforeMove,
                                                                    'moveItem': moveItem
                                                                }"
																	key-prop="key"
																	children-prop="nested"
																	class-prop="class"
																	cross-list
																	group="cross"
															>
																<template slot-scope="{ item }">
																	<div class="nestable-item ">
																		<div class="category-row nest-row"
																			 :class="
																item.type == 'productclass' ? 'red' : ''
																|| item.collapsed ? 'collapsed-parent-'+item.key : ''"
																			 data-collapse="open">

																			<div class="checkbox c-checkbox">
																				<!-- Collapse handler -->
																				<div class="drag-handler">
																					<a href="#"
																					   class="nest-collapser-mini nest-collapser"
																					   @click="collapseNest(item)"
																					   v-if="item.nested.length>0 && !item.collapsed">
																						<i class="icon-arrow-down collapser-icon"></i>
																					</a>
																					<a href="#"
																					   class="nest-collapser-mini nest-collapser"
																					   @click="collapseNest(item)"
																					   v-if="item.nested.length>0 && item.collapsed">
																						<i class="icon-arrow-right collapser-icon"></i>
																					</a>
																				</div>
																				<label class="mb-0">
																					<input
																							type="checkbox"
																							@click="onCheckboxClick(item)"
																							class="select-box"
																							:checked="item.checked ? '1' : '0'"
																							v-model="item.checked"
																					>
																					<span class="fa fa-check"> </span>
																				</label>
																				{{item.text}}
																			</div>
																			<VueNestableHandle :item="item"
																							   class="disabled-drag"></VueNestableHandle>
																		</div>
																	</div>
																</template>
															</VueNestable>
														</div>
													</div>
												</div>

											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--  Content -->
			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-body">
							<div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
								<search @make_search="make_search"/>
								<table class="table table-striped dataTable my-4 w-100" id="supplier_users">
									<thead>
									<tr>
										<th
												:class="{
                          'sorting_asc': ordering === 'supplier',
                          'sorting_desc': ordering === '-supplier'}"
												@click="order('supplier')">Tarnija
										</th>
										<th
												:class="{
                          'sorting_asc': ordering === 'division',
                          'sorting_desc': ordering === '-division'}"
												@click="order('division')">Osakond
										</th>
										<th
												:class="{
                          'sorting_asc': ordering === 'categories',
                          'sorting_desc': ordering === '-categories'}"
												@click="order('categories')">Kategooriad
										</th>
									</tr>
									</thead>
									<tbody>
									<tr :key="row.id" class="gradeX" v-for="(row) in rows">
										<td>{{ row.name }}</td>
										<td>
											<div class="groups" v-for="(rowGroup, idx) in row.groups"
												 :key="'group-'+idx">
												{{rowGroup.name}}
											</div>
										</td>
										<td>
											<div class="category" v-for="(cat,idx) in row.categories" :key="'cat'+idx"
												 v-if="idx < 3">
												{{cat.name}}
												<span
														class="text-success badge-margin"
														v-for="(categoryGroup,idx) in cat.groups" :key="idx">
													{{categoryGroup.name}};
												</span>
											</div>
											<div class="category" v-for="(cat,idx) in row.categories" :key="'cat'+idx"
												 v-if="row.expanded && idx > 3">
												{{cat.name}}
												<span
														class="text-success badge-margin"
														v-for="(categoryGroup,idx) in cat.groups" :key="idx">
													{{categoryGroup.name}};
												</span>
											</div>
											<button
													class="btn btn-link btn-sm pl-0"
													v-if="row.categories.length > 3 && !row.expanded"
													@click="row.expanded = (row.expanded) ? false : true;">{{
												$t('tenderview.more') }} ...
											</button>
											<button
													class="btn btn-link btn-sm pl-0"
													v-if="row.categories.length > 3 && row.expanded"
													@click="row.expanded = (row.expanded) ? false : true;">{{
												$t('tenderview.less') }} ...
											</button>
										</td>
									</tr>
									</tbody>
								</table>
								<pagination
										:page="page"
										:pages="pages"
										:count="count"
										:from="(page - 1) * 30 + 1"
										:to="(page - 1) * 30 + rows.length"
										@paginate="paginate"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- End of content -->


		</div>

		<modal v-if="showModal">
			<h4 class="modal-title" slot="header-text">{{ $t('modal.header.text') }}</h4>
			<div class="modal-body" slot="modal-body">
				<p class="text-bold">{{ $t('modal.section1.header') }}</p>
				<p>{{ modal_data_1 }}</p>
				<p class="text-bold">{{ $t('modal.section2.header') }}</p>
				<p>{{ modal_data_2}}</p>
			</div>
			<div slot="modal_buttons">
				<button class="btn btn-secondary" type="button" @click="close_modal()">{{ $t('modal.close') }}</button>
			</div>
		</modal>

	</section>
</template>

<script>
	import api from '@/api'
	import message from '@/message'
	import {Datetime} from 'vue-datetime'
	import Pagination from '@/components/Pagination.vue'
	import Search from '@/components/Search.vue'
	import {parseApiError} from '@/utils'
	import Modal from '@/components/Modal.vue'
	import Multiselect from 'vue-multiselect'
	import NestableItem from '@/components/Nestable/NestableItem';

	const getData = (id, route, next) => {
		const search = route.query.search
		const ordering = route.query.ordering || 'pk'
		const page = parseInt(route.query.page) || 1
		const start = route.query.start
		const finish = route.query.finish
		const warehouse = route.query.warehouse || null
		const additional = route.query.additional || ''
		const tenderId = route.query.tender_id || null
		const group = route.query.group || null




		if (!id && tenderId) {
			id = tenderId
		}
		if(page > 1 || page < 2) {
			Promise.all([
				api.get('/reports/categories/', {
					params: {
						search: search,
						ordering: ordering,
						page: page,
					}
				}).then(resp => {
					let rowsData = []
					let rows = resp.data.results

					/*rows.forEach(row => {
						rowsData.push({
							0: row.id,
							1: row.code,
							2: row.name,
							3: row.tender_code,
							4: row.period,
							5: row.min_price,
							6: row.max_price
						})
					})*/

					next({
						rows: rows,
						rowsData: rowsData,
						search: search,
						ordering: ordering,
						pages: resp.data.pages,
						count: resp.data.count,
						page: page
					})
				}),
			])
		}
		if(search != null) {
			Promise.all([
				api.get('/reports/categories/', {
					query: {
						search: search,
						ordering: ordering,
						page: page,
						pages:pages,
						count:count
					}
				}).then(resp => {
					let rowsData = []
					let rows = resp.data.results

					/*rows.forEach(row => {
						rowsData.push({
							0: row.id,
							1: row.code,
							2: row.name,
							3: row.tender_code,
							4: row.period,
							5: row.min_price,
							6: row.max_price
						})
					})*/

					next({
						rows: rows,
						rowsData: rowsData,
						search: search,
						ordering: ordering,
						pages: resp.data.pages,
						count: resp.data.count,
						page: page
					})
				}),
			])

		}

		if (id) {
			Promise.all([
				api.get(`/tenders/${id}/`),
				api.get(`/details/`, {
					params: {
						page_size: 500,
						tender: id,
						search: search,
						ordering: ordering,
						page: 1
					}
				}),
				api.get('/warehouses/?is_active=true&page_size=1000'),
				api.get(`/profile/`)
			])
				.then(([tender, chosen, warehouses, profile]) => {
					let rows = {}
					api.get(`/details/`, {
						params: {
							status: 'PREPARED',
							warehouse: tender.data.warehouse,
							page_size: 50,
							search: search,
							ordering: ordering,
							page: page
						}
					})
						.then(resp => {
							rows = resp.data
							rows.results.forEach(r => {
								if (r.qty === null) {
									r.qty = r.replenishment_qty + r.replacement_qty > 0 ? r.replenishment_qty + r.replacement_qty : 0
								}
							})

							let rowsChosen = chosen.data.results
							rowsChosen.forEach(r => {
								if (r.qty === null) {
									r.qty = r.replenishment_qty + r.replacement_qty > 0 ? r.replenishment_qty + r.replacement_qty : 0
								}
							})

							let userWarehouses = []
							warehouses.data.results.forEach(w => {
								if (w.group === tender.data.group) {
									userWarehouses.push(w)
								}
							})

							tender.data.warehouse = {
								'id': tender.data.warehouse,
								'name': tender.data.warehouse_name
							}

							tender.data.group = {
								'id': tender.data.group,
								'name': tender.data.group_name
							}

							next({
								tender: tender.data,
								user_warehouse: tender.data.warehouse,
								details: rows.results,
								search: search,
								ordering: ordering,
								chosen: rowsChosen,
								page: page,
								pages: rows ? rows.pages : 1,
								warehouses: userWarehouses,
								groups: profile.data.results ? profile.data.results[0].warehouse_groups_options : []
							})
						})
				})
		} else {
			Promise.all([
				//api.get('/reports/categories/', {}),
				api.get('/categories/tree/' + localStorage.selectedDivision + '/'),
				api.get('/groups/?page_size=100')
			])
				.then(([treeList, groups]) => {
					let rows = [];
					let list = [];

					if (treeList.data.tree.list.length > 0) {
						treeList.data.tree.list.forEach(r => {

							let childRows = [];
							// First dimension
							r.nested.forEach(child => {
								let secondChildList = [];

								// Second dimension
								if (child.nested.length > 0) {
									child.nested.forEach(secondChild => {
										// Third last dimension
										let thirdChildList = [];
										secondChild.nested.forEach(thirdChild => {
											let tempThirdChild = {
												key: thirdChild.key,
												class: 'purple-text-color',
												text: thirdChild.text,
												productClass: thirdChild.class,
												type: 'category',
												collapsed: false,
												nested: thirdChild.nested,
												visible: true,
												card: 'tree',
											};
											thirdChildList.push(tempThirdChild);
										});

										let secondTempChild = {
											key: secondChild.key,
											class: 'purple-text-color',
											text: secondChild.text,
											productClass: secondChild.class,
											type: 'category',
											collapsed: false,
											nested: thirdChildList,
											visible: true,
											card: 'tree',
										};
										secondChildList.push(secondTempChild);
									});
								}

								let childRow = {
									key: child.key,
									class: 'purple-text-color',
									text: child.text,
									productClass: child.class,
									type: 'category',
									collapsed: false,
									nested: secondChildList,
									visible: true,
									card: 'tree',
								};
								childRows.push(childRow);
							});
							let rowData = {
								key: r.key,
								class: 'purple-text-color',
								text: r.text,
								productClass: r.class,
								type: 'category',
								collapsed: false,
								nested: childRows,
								visible: true,
								card: 'tree',
							};
							list.push(rowData);
						})
					}
					/*categories.data.results.forEach(r => {
						rows.push({
							id: r.id,
							name: r.name,
							groups: r.groups,
							categories: r.categories,
							expanded: false,
						});
					})*/

					next({
						search: search,
						ordering: ordering,
						page: page,
						pages: rows ? rows.pages : 1,
						//count: rows.data.count,
						warehouses: groups && groups.length === 1 ? warehouses.data.results : [],
						groups: groups.data.results,
						rows: rows,
						listItems: list,
					})
				})
		}
	}

	export default {
		components: {
			datetime: Datetime,
			modal: Modal,
			Multiselect,
			NestableItem,
			pagination: Pagination,
			search: Search
		},
		data() {
			return {
				treeFilterOpen: false,
				categoryGroupReg: [],
				tender: {
					id: null,
					start: null,
					finish: null,
					additional_info: '',
					warehouse: null
				},
				filter: {
					search: null,
					group: [],
					category: null
				},
				rows: [
					{
						supplier: 'Ivar OU',
						division: '1801190001',
						expanded: false,
						categories: [
							{
								id: 1,
								name: 'Kategooria 1'
							},
							{
								id: 2,
								name: 'Kategooria 1.5'
							},
							{
								id: 3,
								name: 'Kategooria 2'
							},
							{
								id: 4,
								name: 'Kategooria 2.5'
							},
							{
								id: 5,
								name: 'Kategooria 3'
							},
							{
								id: 6,
								name: 'Kategooria 3.1'
							},
							{
								id: 7,
								name: 'Kategooria 3.2'
							},
							{
								id: 8,
								name: 'Kategooria 8'
							},
						]
					}
				],
				tableRows: [
					{
						customer: 'Ivar OÜ',
						filiaal: '1801190001',
						'category': [
							{
								id: 1,
								name: 'Kategooria 1'
							},
							{
								id: 2,
								name: 'Kategooria 1.5'
							},
							{
								id: 3,
								name: 'Kategooria 2'
							},
							{
								id: 4,
								name: 'Kategooria 2.5'
							},
							{
								id: 5,
								name: 'Kategooria 3'
							},
							{
								id: 6,
								name: 'Kategooria 3.1'
							},
							{
								id: 7,
								name: 'Kategooria 3.2'
							},
							{
								id: 8,
								name: 'Kategooria 8'
							},
						],
						visible: true,
						expanded: false,
					},
					{
						customer: 'Metsad OÜ',
						filiaal: '1801190002',
						'category': [
							{
								id: 1,
								name: 'Kategooria 1'
							},
							{
								id: 2,
								name: 'Kategooria 1.5'
							},
						],
						visible: true,
						expanded: false,
					},
					{
						customer: 'Ivar OÜ',
						filiaal: '1801190003',
						'category': [
							{
								id: 2,
								name: 'Kategooria 1.5'
							},
						],
						visible: true,
						expanded: false,
					},
					{
						customer: 'Ivar OÜ',
						filiaal: '1801190004',
						'category': [],
						visible: true,
						expanded: false,
					}
				],
				listItems: [],
				newCategories: [
					{
						key: 5,
						class: 'purple-text-color',
						text: 'Kategooria 1',
						type: 'category'
					},
					{
						key: 6,
						class: 'blue-text-color',
						text: 'Kategooria 2',
						type: 'category'
					},
					{
						key: 8,
						class: 'red-text-color',
						text: 'Kategooria 3',
						type: 'category'
					},
					{
						key: 9,
						text: 'Kategooria 4',
						type: 'category'
					}
				],
				productClasses: [
					{
						key: 10,
						class: 'purple-text-color',
						text: 'Tooteklass',
						type: 'productclass'
					},
					{
						key: 11,
						class: 'blue-text-color',
						text: 'Tooteklass',
						type: 'productclass'
					},
					{
						key: 12,
						class: 'red-text-color',
						text: 'Tooteklass',
						type: 'productclass'
					},
					{
						key: 13,
						text: 'Tooteklass',
						type: 'productclass'
					}
				],
				unactiveCategories: [
					{
						key: 14,
						class: 'purple-text-color',
						text: 'Kategooria 56',
						type: 'unactive'
					},
					{
						key: 15,
						class: 'blue-text-color',
						text: 'Kategooria 57',
						type: 'unactive'
					},
					{
						key: 16,
						class: 'red-text-color',
						text: 'Kategooria 58',
						type: 'unactive'
					},
					{
						key: 17,
						text: 'Kategooria 52',
						type: 'unactive'
					}
				],

				details: [],
				warehouses: [],
				groups: [],
				chosen: [],
				search: null,
				user_warehouse: null,
				ordering: null,
				count: null,
				errors: {},
				page: null,
				pages: null,
				showModal: false,
				modal_data_1: null,
				modal_data_2: null,
				searchBarInput: '',
				warehouse_changed: false,
				selectedDivision: 1,
			}
		},
		mounted() {
			this.$parent.menu = 'productcatreport'
			this.$parent.submenu = ''
			this.$i18n.locale = this.$store.getters.language

			if (localStorage.selectedDivision > 0) {
				this.selectedDivision = localStorage.selectedDivision;
			}
		},
		computed: {
			is_administrator () {
				return this.$store.getters.user_group === 'Administrator'
			},
			is_contractor () {
				return this.$store.getters.user_group === 'Contractor'
			},
			number_of_lines(row) {
				if (!row.expanded)
					return 3;

				return row.category.length;
			},
			nestableItems: {
				get() {
					return this.$store.state.nestableItems;
				},
				set(value) {
					this.$store.dispatch('updateElements', value);
				}
			},
			is_supplier() {
				return this.$store.getters.user_group === 'Supplier'
			},
		},
		methods: {
			order (o) {
				if (o === this.ordering) {
					this.$router.push({
						query: {
							search: this.search,
							ordering: '-' + o,
							page: 1,
							filter_code: this.filter_code,
							filter_name: this.filter_name,
							filter_start: this.filter_start,
							filter_finish: this.filter_finish
						}
					})
				} else {
					this.$router.push({
						query: {
							search: this.search,
							ordering: o,
							page: 1,
							filter_code: this.filter_code,
							filter_name: this.filter_name,
							filter_start: this.filter_start,
							filter_finish: this.filter_finish
						}
					})
				}
			},
			paginate (p) {
				this.$router.push({
					query: {
						page: p,
						search: this.search,
						ordering: this.ordering,
						filter_code: this.filter_code,
						filter_name: this.filter_name,
						filter_start: this.filter_start,
						filter_finish: this.filter_finish
					}
				})
			},
			collapseExpand(value) {
				for (var i = 0; i < this.listItems.length; i++) {

					if (this.listItems[i].nested.length > 0) {
						this.listItems[i].collapsed = value;
						this.toggleAccordion(
							this.listItems[i], this.listItems[i].collapsed
						);
					}

					// Second dimension
					if (this.listItems[i].nested.length > 0) {
						for (var j = 0; j < this.listItems[i].nested.length; j++) {
							if (this.listItems[i].nested[j].nested.length > 0) {
								this.listItems[i].nested[j].collapsed = (!this.listItems[i].nested[j].collapsed) ? true : false;
								this.toggleAccordion(
									this.listItems[i].nested[j],
									this.listItems[i].nested[j].collapsed
								);
							}

							// Third dimension
							for (var k = 0; k < this.listItems[i].nested[j].nested.length; k++) {
								if (this.listItems[i].nested[j].nested[k].nested.length > 0) {
									this.listItems[i].nested[j].nested[k].collapsed = (!this.listItems[i].nested[j].nested[k].collapsed) ? true : false;
									this.toggleAccordion(
										this.listItems[i].nested[j].nested[k],
										this.listItems[i].nested[j].nested[k].collapsed
									);
								}
							}
						}
					}
				}
			},
			collapseNest(item) {
				for (var i = 0; i < this.listItems.length; i++) {
					if (this.listItems[i].key == item.key) {
						this.listItems[i].collapsed = (!this.listItems[i].collapsed) ? true : false;
						this.toggleAccordion(item, this.listItems[i].collapsed);
					}

					// Second dimension
					if (this.listItems[i].nested.length > 0) {
						for (var j = 0; j < this.listItems[i].nested.length; j++) {
							if (this.listItems[i].nested[j].key == item.key) {
								this.listItems[i].nested[j].collapsed = (!this.listItems[i].nested[j].collapsed) ?
									true : false;
								this.toggleAccordion(item, this.listItems[i].nested[j].collapsed);
							}
							// Third dimension
							if (this.listItems[i].nested[j].nested.length > 0) {
								for (var k = 0; k < this.listItems[i].nested[j].nested.length; k++) {
									if (this.listItems[i].nested[j].nested[k].key == item.key) {
										this.listItems[i].nested[j].nested[k].collapsed = (!this.listItems[i].nested[j].nested[k].collapsed) ?
											true : false;
										this.toggleAccordion(item, this.listItems[i].nested[j].nested[k].collapsed);
									}
								}
							}
						}
					}
				}
			},
			toggleAccordion(item, value) {
				var collapsed = document.getElementsByClassName('nestable-item-' + item.key);
				if (collapsed.length > 0) {
					for (var i = 0; i < collapsed.length; i++) {
						if (value)
							collapsed[i].querySelector('ol').classList.add('hidden')
						else
							collapsed[i].querySelector('ol').classList.remove('hidden')
					}
				}
			},
			resetFilters() {
				this.filter.group = [];
				this.filter.search = null;
				this.filter.category = null;
				Promise.all([
					api.get('/reports/categories/'),
					api.get('/groups/?page_size=100')
				])
					.then(([categories, groups]) => {
						let rows = [];

						categories.data.results.forEach(r => {
							rows.push({
								id: r.id,
								name: r.name,
								groups: r.groups,
								categories: r.categories,
								expanded: false,
							});
						})
						this.rows = rows;
					})
			},
			filterRows() {
				let filterData = {};
				if (this.filter.search != null) {
					filterData['filter_name'] = this.filter.search;
				}

				let selectedCategories = [];
				this.listItems.forEach(r => {
					if (r.checked) {
						selectedCategories.push(r.text);
						if (r.nested.length > 0) {
							r.nested.forEach(first => {
								if (first.checked)
									selectedCategories.push(first.text)
							})
						}
					}
				})
				if (selectedCategories.length > 0) {
					filterData['filter_category'] = selectedCategories.join('|');
				}

				if (this.filter.group.length > 0) {
					filterData['filter_group'] = this.filter.group.join('|');
				}

				Promise.all([
					api.get('/reports/categories/', {
						params: filterData
					}),
					api.get('/categories/tree/' + localStorage.selectedDivision + '/'),
					api.get('/groups/?page_size=100'),
				])
					.then(([categories, tree, groups]) => {
						let rows = [];

						categories.data.results.forEach(r => {
							rows.push({
								id: r.id,
								name: r.name,
								groups: r.groups,
								categories: r.categories,
								expanded: false,
							});
						})
						this.pages = categories.data.pages;
						this.count = categories.data.count;
						this.rows = rows;
					})
			},
			filterByGroup(id, name) {
				this.selectedDivision = id;
				// Load tree
				Promise.all([
					api.get('/categories/tree/' + id + '/'),
				])
					.then(([treeList]) => {

						let list = [];

						//list
						if (treeList.data.tree.list.length > 0) {
							treeList.data.tree.list.forEach(r => {

								let childRows = [];
								// First dimension
								r.nested.forEach(child => {
									let secondChildList = [];

									// Second dimension
									if (child.nested.length > 0) {
										child.nested.forEach(secondChild => {
											// Third last dimension
											let thirdChildList = [];
											secondChild.nested.forEach(thirdChild => {
												let tempThirdChild = {
													key: thirdChild.key,
													class: 'purple-text-color',
													text: thirdChild.text,
													productClass: thirdChild.class,
													type: 'category',
													collapsed: false,
													nested: thirdChild.nested,
													visible: true,
													card: 'tree',
												};
												thirdChildList.push(tempThirdChild);
											});

											let secondTempChild = {
												key: secondChild.key,
												class: 'purple-text-color',
												text: secondChild.text,
												productClass: secondChild.class,
												type: 'category',
												collapsed: false,
												nested: thirdChildList,
												visible: true,
												card: 'tree',
											};
											secondChildList.push(secondTempChild);
										});
									}

									let childRow = {
										key: child.key,
										class: 'purple-text-color',
										text: child.text,
										productClass: child.class,
										type: 'category',
										collapsed: false,
										nested: secondChildList,
										visible: true,
										card: 'tree',
									};
									childRows.push(childRow);
								});
								let rowData = {
									key: r.key,
									class: 'purple-text-color',
									text: r.text,
									productClass: r.class,
									type: 'category',
									collapsed: false,
									nested: childRows,
									visible: true,
									card: 'tree',
								};
								list.push(rowData);
							})
							this.listItems = list;
						}
					})
			},
			setAllCategories(checked) {
				for (let index = 0; index < this.listItems.length; index++) {
					this.listItems[index].checked = checked;
					for (let childIndex = 0; childIndex < this.listItems[index].nested.length; childIndex++) {
						this.listItems[index].nested[childIndex].checked = checked;
					}
				}
			},
			// Checks and detects if parent is clicked, check its childs
			onCheckboxClick(item) {
				if (item.nested.length > 0 && item.checked == false) {
					for (let index = 0; index < this.listItems.length; index++) {
						const element = this.listItems[index];
						if (element.key == item.key) {
							for (let childIndex = 0; childIndex < this.listItems[index].nested.length; childIndex++) {
								this.listItems[index].nested[childIndex].checked = true;
							}
						}
					}
				}
			},
			filterBySearchBar() {
				for (let index = 0; index < this.tableRows.length; index++) {
					const element = this.tableRows[index];
					if (element.customer.includes(this.searchBarInput) || element.filiaal.includes(this.searchBarInput) || element.category.includes(this.searchBarInput)) {
						this.tableRows[index].visible = true;
					} else {
						this.tableRows[index].visible = false;
					}
				}

			},
			toggleTreeFilter() {
				this.treeFilterOpen = (this.treeFilterOpen) ? false : true;
			},
			editItem(item) {
				this.$router.push({name: 'admin_product_cat_add'});
			},
			addNewCategory() {
				this.$router.push({name: 'admin_product_cat_add'});
			},
			addNestCategory(item) {
				this.listItems.push(item);

				//Remove from current list
				switch (item.type) {
					case 'category':
						for (let index = 0; index < this.newCategories.length; index++) {
							if (item.key == this.newCategories[index].key)
								this.newCategories.splice(index, 1);
						}
						break;

					case 'productclass':
						for (let index = 0; index < this.productClasses.length; index++) {
							if (item.key == this.productClasses[index].key)
								this.productClasses.splice(index, 1);
						}
						break;

					case 'unactive':
						for (let index = 0; index < this.unactiveCategories.length; index++) {
							if (item.key == this.unactiveCategories[index].key)
								this.unactiveCategories.splice(index, 1);
						}
						break;

					default:
						break;
				}

			},
			revertNestCategory(item) {

				for (let index = 0; index < this.listItems.length; index++) {
					if (item.key == this.listItems[index].key)
						this.listItems.splice(index, 1);
				}

				switch (item.type) {
					case 'category':
						this.newCategories.push(item);
						break;

					case 'productclass':
						this.productClasses.push(item);
						break;

					case 'unactive':
						this.unactiveCategories.push(item);
						break;

					default:
						break;
				}

			},
			beforeMove({dragItem, pathFrom, pathTo}) {
				// Full path is shown as single row : moving to tree, moving to uued

				return true
			},
			moveItem({dragItem, pathFrom, pathTo}) {
			},
			select_group(g) {
				this.errors = {}
				this.tender.warehouse = null
				api.get('/warehouses/', {
					params: {
						is_active: true,
						page_size: 100,
						group: g.id
					}
				})
					.then(r => {
						this.warehouses = r.data.results
					})
			},
			close_modal() {
				this.showModal = false
			},
			open_modal(data1, data2) {
				this.showModal = true
				this.modal_data_1 = data1
				this.modal_data_2 = data2
			},
			make_search() {
				//this.$parent.make_search(this.search, this.ordering)
				this.$router.push({
					query: {
						search: this.search,
						ordering: this.ordering,
						page: this.page,
						start: this.tender.start,
						finish: this.tender.finish,
						warehouse: this.tender.warehouse,
						group: this.tender.group,
						additional: this.tender.additional_info,
						tender_id: this.tender.id
					}
				})
			},
		},
		beforeRouteEnter(to, from, next) {
			getData(to.params.id, to, data => {
				next(vm => {
					Object.assign(vm.$data, data)
				})
			})
		},
		beforeRouteUpdate(to, from, next) {
			getData(to.params.id, to, data => {
				Object.assign(this.$data, data)
				next()
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/ProductCategoriesList.vue